/* eslint-disable no-console */
import LocalStorageService from 'client/util/LocalStorageService';

function createLoggingService(localStorageService = LocalStorageService) {
  const logLevel = localStorageService.getValue('7-19-21-jcLogLevel');

  return {
    debug(...args) {
      if (logLevel === 'DEBUG') {
        console.log('DEBUG: ', ...args);
      }
    },
    /**
     * This is for usage in code paths we should not be in.
     * It isn't gated because we want to see it in QA and it should fail tests that trigger it.
     */
    error(...args) {
      console.error('ERROR: ', ...args);
    },
  };
}

export default createLoggingService();
